<div class="card">
  <app-header
    [titulo]="isEditMode ? 'Editar Processo' : 'Novo Processo'"
    [descricao]="isEditMode ? 'Atualizar dados do processo de integração' : 'Criar um novo processo de integração'">
  </app-header>

  <form [formGroup]="form" (ngSubmit)="salvar()">
    <div class="p-fluid grid">
      <div class="field col-12">
        <p-floatLabel>
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [class.ng-invalid]="campoInvalido('nome')"
            [class.ng-dirty]="campoInvalido('nome')"
          />
          <label for="nome">Nome do Processo *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('nome')">
          Nome é obrigatório (mínimo 3 caracteres).
        </small>
      </div>

      <div class="field col-12">
        <p-floatLabel>
          <textarea
            pInputTextarea
            id="descricao"
            formControlName="descricao"
            rows="4"
            [class.ng-invalid]="campoInvalido('descricao')"
            [class.ng-dirty]="campoInvalido('descricao')"
          ></textarea>
          <label for="descricao">Descrição *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('descricao')">
          Descrição é obrigatória.
        </small>
      </div>
    </div>

    <!-- Botões de Ação -->
    <div class="flex justify-content-end gap-2 mt-4 pt-4 border-top-1 surface-border">
      <p-button
        label="Voltar"
        icon="pi pi-arrow-left"
        severity="secondary"
        (onClick)="voltar()"
        [disabled]="loading">
      </p-button>

      <p-button
        [label]="isEditMode ? 'Atualizar' : 'Salvar e Configurar'"
        icon="pi pi-check"
        severity="success"
        type="submit"
        [loading]="loading">
      </p-button>
    </div>
  </form>
</div>
